import Layout from "@/components/feature/Layout";
import PageHero from "@/components/feature/PageHero";
import Button from "@/components/base/Button";
import CTASection from "@/components/feature/CTASection";
import { useSiteData } from "@/context/SiteDataContext";
import { useT } from "@/lib/useSiteText";

export default function Seguridad() {
  const { data, whatsappLink } = useSiteData();
  const t = useT();
  const etiqueta = t("seguridad.etiqueta");
  const descripcion = t("seguridad.descripcion");
  const bloqueDescripcion = t("seguridad.bloque_descripcion");
  const fotos = (["1", "2", "3", "4"] as const).map((n) => ({
    src: t(`seguridad.foto${n}`),
    alt: t(`seguridad.foto${n}_alt`),
  }));
  const hero = data.pages.seguridad;
  const medidas = data.contentBlocks.seguridad?.medidas ?? [];

  return (
    <Layout>
      <PageHero
        titulo={hero.hero_titulo}
        descripcion={hero.hero_descripcion}
        imagen={hero.hero_imagen_url}
        alt={hero.hero_imagen_alt}
      />

      <section className="bg-background-50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-2xl">
            {etiqueta && <span className="text-sm font-semibold text-accent-600">{etiqueta}</span>}
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              {t("seguridad.titulo")}
            </h2>
            {descripcion && <p className="mt-4 text-foreground-600 leading-relaxed">{descripcion}</p>}
          </div>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {medidas.map((m) => (
              <div key={m.id} className="rounded-lg bg-background-100 p-6 hover:bg-background-200 transition-colors">
                <span className="w-12 h-12 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center">
                  <i className={`${m.icono} text-2xl`} />
                </span>
                <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-900">{m.titulo}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{m.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-primary-900">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div className="order-2 lg:order-1 grid grid-cols-2 gap-4">
              {fotos.map(
                (foto, i) =>
                  foto.src && (
                    <img
                      key={i}
                      src={foto.src}
                      alt={foto.alt}
                      className={`rounded-lg w-full h-40 object-cover object-top${i % 2 === 1 ? " mt-6" : ""}`}
                    />
                  )
              )}
            </div>
            <div className="order-1 lg:order-2">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50">
                {t("seguridad.bloque_titulo")}
              </h2>
              {bloqueDescripcion && <p className="mt-4 text-background-200 leading-relaxed">{bloqueDescripcion}</p>}
              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <Button href={whatsappLink(t("wa.seguridad"))} variant="accent" icon="ri-whatsapp-line">
                  {t("seguridad.boton_preguntar")}
                </Button>
                <Button to="/contacto" className="bg-background-50 text-primary-800 hover:bg-background-100">
                  {t("seguridad.boton_visita")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CTASection titulo={hero.cta_titulo ?? undefined} descripcion={hero.cta_descripcion ?? undefined} />
    </Layout>
  );
}